function getYouTubeId(url: string): string | null {
  const match = url.match(
    /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/)|youtube-nocookie\.com\/embed\/)([A-Za-z0-9_-]{6,})/
  )
  return match?.[1] ?? null
}

export function EsportsPlayer({
  videoUrl,
  posterUrl,
  backupVideoUrl,
}: {
  videoUrl?: string
  posterUrl?: string
  backupVideoUrl?: string
}) {
  const normalizedUrl = videoUrl?.trim()
  const normalizedPosterUrl = posterUrl?.trim()
  const normalizedBackupUrl = backupVideoUrl?.trim()

  if (!normalizedUrl) {
    return null
  }

  const youtubeId = getYouTubeId(normalizedUrl)
  const normalizedPoster = normalizedPosterUrl || "/images/home/gamers.webp"
  const effectivePoster = normalizedPoster

  if (youtubeId) {
    return (
      <div className="esports-player column__wide mx-auto aspect-video max-w-[1200px] border-4 border-[var(--white)] bg-[var(--blue)] leading-[0] shadow-[10px_10px_0_var(--blue-50)] md:max-w-[800px] lg:max-w-[950px] xl:max-w-[1150px]">
        <iframe
          title="esports"
          id="ytplayer"
          width="100%"
          height="100%"
          src={normalizedUrl}
          allow="autoplay; encrypted-media; picture-in-picture"
          allowFullScreen
          loading="lazy"
          style={{ border: 0 }}
        />
      </div>
    )
  }

  return (
    <div className="esports-player column__wide mx-auto aspect-video max-w-[1200px] border-4 border-[var(--white)] bg-[var(--blue)] leading-[0] shadow-[10px_10px_0_var(--blue-50)] md:max-w-[800px] lg:max-w-[950px] xl:max-w-[1150px]">
      <video
        key={normalizedUrl}
        title="esports"
        controls
        controlsList="nodownload"
        loop
        muted
        playsInline
        preload="none"
        poster={effectivePoster}
        style={{
          border: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "50% 47%",
        }}
      >
        <source src={normalizedUrl} />
        {normalizedBackupUrl && normalizedBackupUrl !== normalizedUrl ? (
          <source src={normalizedBackupUrl} />
        ) : null}
      </video>
    </div>
  )
}

export default EsportsPlayer
